import type { Components, Theme } from '@mui/material'

export const MuiToast: Components['MuiSnackbar'] = {
  styleOverrides: {
    root: {
      maxWidth: 400,
    },
  },
}

export const MuiToastContent = (
  theme: Theme,
): Components['MuiSnackbarContent'] => ({
  styleOverrides: {
    root: {
      ...theme.typography.bodyStrong__Wallfund,
      backgroundColor: theme.palette.background.bg2,
      border:"1px solid",
      borderColor:theme.palette.stroke?.stroke2,
      color:theme.palette.text.text,
      boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.02), 0px 8px 20px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: 'var(--corner_radius_m)',
      padding: 0,
    },
    message: {
      padding: '10px 16px',
    },
    action: {
      paddingLeft: 0,
      marginRight: 0,
    },
  },
})
